"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var modal_1 = require("./modal");
var ModalDialog = /** @class */ (function (_super) {
    tslib_1.__extends(ModalDialog, _super);
    function ModalDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalDialog.prototype.handleBack = function (e) {
        e.preventDefault();
        this.props.onBack();
    };
    ModalDialog.prototype.handleSubmit = function (e) {
        e.preventDefault();
        this.props.onSubmit();
    };
    ModalDialog.prototype.handleClose = function (e) {
        e.preventDefault();
        this.props.onRequestClose();
    };
    ModalDialog.prototype.handleDelete = function (e) {
        e.preventDefault();
        this.props.onDelete();
    };
    ModalDialog.prototype.handleCloseOrBack = function (e) {
        if (this.props.onBack) {
            this.handleBack(e);
        }
        else {
            this.handleClose(e);
        }
    };
    Object.defineProperty(ModalDialog.prototype, "saveButtonText", {
        get: function () {
            if (this.props.isSaving) {
                return I18n.t('commons.modalDialog.wait');
            }
            return this.props.saveButtonText || I18n.t('commons.modalDialog.save');
        },
        enumerable: true,
        configurable: true
    });
    ModalDialog.prototype.renderDelete = function () {
        if (!this.props.onDelete)
            return null;
        return (React.createElement("div", null,
            React.createElement("button", { className: "reverb-modal__actions__delete", onClick: this.handleDelete }, this.props.deleteButtonText || I18n.t('commons.modalDialog.delete'))));
    };
    Object.defineProperty(ModalDialog.prototype, "saveButtonProps", {
        get: function () {
            var semanticHtmlProps = {
                className: 'reverb-modal__actions__save',
                type: 'submit',
                disabled: (this.props.isSaving || this.props.isDisabled)
            };
            if (this.props.containsFormElement) {
                return tslib_1.__assign(tslib_1.__assign({}, semanticHtmlProps), { onClick: this.handleSubmit });
            }
            return semanticHtmlProps;
        },
        enumerable: true,
        configurable: true
    });
    ModalDialog.prototype.renderActions = function () {
        return (React.createElement("div", { className: "reverb-modal__actions" },
            React.createElement("div", null,
                React.createElement("button", tslib_1.__assign({}, this.saveButtonProps), this.saveButtonText),
                !this.props.hideBackLink &&
                    React.createElement("button", { className: "reverb-modal__actions__back", onClick: this.handleCloseOrBack }, this.props.backButtonText || I18n.t('commons.modalDialog.goBack'))),
            this.renderDelete()));
    };
    ModalDialog.prototype.renderBackButton = function () {
        if (!this.props.onBack)
            return null;
        return (React.createElement("button", { className: "reverb-modal__back", onClick: this.handleBack }));
    };
    ModalDialog.prototype.renderModalContents = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "reverb-modal__dialog-body" }, this.props.children),
            this.renderActions(),
            this.renderBackButton()));
    };
    ModalDialog.prototype.renderFormOrDiv = function () {
        if (this.props.containsFormElement) {
            return this.renderModalContents();
        }
        return (React.createElement("form", { action: "#", onSubmit: this.handleSubmit }, this.renderModalContents()));
    };
    ModalDialog.prototype.render = function () {
        return (React.createElement(modal_1.default, { id: this.props.id, isOpen: this.props.isOpen, onRequestClose: this.props.onRequestClose, headerTitle: this.props.headerTitle, headerSubtitle: this.props.headerSubtitle, shouldCloseOnOverlayClick: true, newClose: true, sidebarContent: this.props.sidebarContent, size: this.props.size }, this.renderFormOrDiv()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ModalDialog.prototype, "handleBack", null);
    tslib_1.__decorate([
        bind_1.default
    ], ModalDialog.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], ModalDialog.prototype, "handleClose", null);
    tslib_1.__decorate([
        bind_1.default
    ], ModalDialog.prototype, "handleDelete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ModalDialog.prototype, "handleCloseOrBack", null);
    return ModalDialog;
}(React.Component));
exports.default = ModalDialog;
//# sourceMappingURL=modal_dialog.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/modal_dialog.js
// module id = ndHI
// module chunks = 20 21